<template>
    <div id="WarrantyWorkOrder">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Work Order</div>
                    <div class="web-action-btn">
                        <div class="btn-groups text-right">
                            <router-link class="btn btn-primary" v-bind:to="{name: 'WarrantyClaimList'}" > <i class="fp-back"> </i> Back</router-link>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content warranty-wo">

                        <section class="internal-container border-top-table-fl">
                            <div class="form-row section-divider">
                                <div class="col-md-6">
                                    <div class="row form-group" v-if="wo_no != ''">
                                        <label class="col"># Wo:</label>
                                        <span class="col"> {{ wo_no }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Created By:</label>
                                        <span class="col"> {{ created_by }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col"># Serial:</label>
                                        <span class="col"> {{ vin }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Customer:</label>
                                        <span class="col"> {{ customer }} </span>
                                    </div>
                                    <!-- <div class="row form-group">
                                        <label class="col">Wo Cost:</label>
                                        <span class="col"> {{ wo_cost }} </span>
                                    </div> -->
                                </div>
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col"># Original Wo:</label>
                                        <span class="col"> {{ original_wo }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Vendor:</label>
                                        <span class="col"> {{ vendor }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Unit:</label>
                                        <span class="col"> {{ unit_no }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Collection Amount:</label>
                                        <span class="col"> {{ collection_amount }} </span>
                                    </div>
                                </div>
                            </div>
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="WarrantyWorkOrderForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label">Open Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="open_date" name="open_date" :disabled="readOnly" v-model="open_date" :config="optionsDate" aria-describedby="basic-addon3" class='cal-icon'></date-picker>
                                            <label for="open_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="state">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location." :disabled="true" label="text" class='close-remove' :options="locationArr">
                                        </v-select>
                                        <div class="field-error">{{location_error_msg}}</div>
                                    </div>
                                </div>


                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require w-25">Component</th>
                                                <th scope="col" class="w-25">Task</th>
                                                <th scope="col" class="text-right">Labor</th>
                                                <th scope="col" class="text-right">Material</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <v-select v-model="component_category_id" :disabled="readOnly" class="close-remove" name="component_category_id" placeholder="Select Component Category." label="text" :options="vmrsArr" :id="'component_category_id'" @search="onSearchVMRS" :filterable="false">
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <v-select v-model="taskid" class="close-remove" :disabled="readOnly" name="taskid" placeholder="Select Task." label="text" :options="workOrderTaskArr" :id="'taskid'">
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control text-right" v-model="labor_amount" :disabled="readOnly" id="labor_amount" @keypress="isNumber($event)" placeholder="Enter Labor Amount" name="labor_amount">
                                                    <!-- <div class="field-error">{{ read.from_value }}</div> -->
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control text-right" v-model="part_amount" :disabled="readOnly" id="part_amount" @keypress="isNumber($event)" placeholder="Enter Labor Amount" name="part_amount">
                                                </td>

                                                <!-- <td class="text-center valign-middle">
                                                    <template v-if="rows.length != 1">
                                                         <a href="javascript:void(0)" v-on:click.prevent="removeElement(index);"> <i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- <div class="btn-groups">
                                        <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                            <i class="fp-add"></i> Add Line Item
                                        </button>
                                    </div> -->
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups" v-if="!readOnly">
                                    <button type="submit" id="createCollectionBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="createWarrantyWorkOrder">
                                    <i class="fp-reload"> </i>  Update
                                    </button>

                                    <button type="submit" id="createCollectionBtn" v-else class="btn btn-primary" v-on:click.prevent="createWarrantyWorkOrder" >
                                    <i class="fp-save"> </i>  Save
                                    </button>

                                    <button type="submit" id="createAndContinueCollectionBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="createWarrantyWorkOrder(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>

                                    <button type="submit" id="cancelCollectionBtn" class="btn btn-tertiary" v-on:click.prevent="BackWarrantyList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {
    contractMixins
} from '../mixins/contractMixins';

    export default {
        name: "ProgramList",
        metaInfo() {
            return {title: "Warranty Work Order List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,contractMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            term_value: false,
            canUpdateProgram:false,
            canAddProgram:false,
            claim_number: "",
            description: "",
            warranty: null,
            wo_no:'',
            original_wo:'',
            created_by: "",
            vin: "",
            periodTypeArr:[{value:"month",text:"Month"},{value:"year",text:"Year"}],
            periodType:{value:"month",text:"Month"},
            wo_cost:"",
            loading:false,
            vendor:'',
            vendor_claim_number:'',
            disposition:'',
            cost_claimed:0,
            claim_date:'',
            workOrderTaskArr: [],
            optionsDate: {
                format: 'MM/DD/YYYY hh:mm:ss a',
                useCurrent: false,
                showClose: true,
            },
            wo_item:'',
            claim_type:'',
            unit_no:'',
            collection_amount:'',
            rows:[],
            customer:'',
            vmrsArr:[],
            location_error_msg:'',
            location_id:'',
            locationArr:[],
            open_date:'',
            vehicle_id:'',
            customer_id:'',
            work_order_id:'',
            wo_item_id:'',
            part_amount:'',
            labor_amount:'',
            component_category_id:'',
            taskid:'',
            readOnly:false
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_program') {
                            self.cantAccessPage = true;
                        }
                        // if (permissions[i].name == 'delete_Program') {
                        //     self.term_value = true;
                        // }
                        if (permissions[i].name == 'add_program') {
                            self.canAddProgram = true;
                            self.canUpdateProgram = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
            self.loadFieldData(['workordertask']);
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[2] == 'create'){
                self.loadClaimData(segments[3]);
            }else{
                self.readOnly = true;
                self.loadClaimWoData(segments[3]);
            }
        },
        methods: {
            onSearchVMRS(search, loading) {
                var self = this;
                if (search.length > 2) {

                    loading(true);
                    self.searchField(loading, search, 'vmrs', '');
                }
            },
            BackWarrantyList:function(){
                var self = this;

                self.$router.push('/warranty-claim/list');
            },

            loadClaimData:function(claimId){
                var self = this;

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/warranty-claim-wo/fetch/"+claimId,
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.original_wo = data.content.work_order_no;
                        self.wo_item = data.content.work_order_no+' | '+data.content.code+' | '+data.content.task;
                        self.unit_no = data.content.unit_no;
                        self.vin = data.content.vin;
                        self.claim_date = data.content.claim_date;
                        // self.cost_claimed = data.content.cost_claimed;
                        // self.collection_number = data.content.collection_number;
                        self.outstanding_balance = data.content.outstanding_balance;
                        self.collection_amount = data.content.collection_amount_till_date;
                        self.adjustment_amount_till_date = data.content.adjustment_amount_till_date;
                        self.outstanding_balance = data.content.outstanding_balance;
                        self.old_collection_amount = data.content.collection_amount;
                        self.old_adjustment_amount = data.content.adjustment_amount;
                        self.open_date = data.content.open_date;
                        self.customer = data.content.customer_number+' | '+data.content.customer_name;
                        self.vehicle_id = data.content.vehicle_id;
                        self.created_by = data.content.uName+' '+data.content.uLastname;
                        self.vendor_claim_number = data.content.vendor_claim_number;
                        self.customer_id = data.content.customer_id;
                        self.work_order_id = data.content.work_order_id;
                        self.wo_item_id = data.content.wo_item_id;
                        self.location_id = {text:data.content.locCode+' | '+data.content.location,value:data.content.location_id};
                        if (data.content.vendor_id){
                            self.vendor = data.content.veName;
                        }
                        // self.component_category_id
                        // self.rows.push({
                        self.item_id = 0;
                        self.component_category_id = {text:data.content.vmrsCode+' | '+data.content.code,value:data.content.vmrsid};
                        self.taskid = {value:data.content.taskId,text:data.content.task};
                        self.labor_amount = data.content.collection_amount_till_date;
                        self.part_amount = '';
                        // });
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'warranty-work-order-search')
                    }
                });
            },
            loadClaimWoData:function(woId){
                var self = this;

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/warranty-wo/fetch/"+woId,
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.wo_no = data.content.work_order_no;
                        self.wo_item = data.content.work_order_no+' | '+data.content.code+' | '+data.content.task;
                        self.unit_no = data.content.unit_no;
                        self.vin = data.content.vin;
                        self.claim_date = data.content.claim_date;
                        self.collection_amount = data.content.collection_amount_till_date;
                        self.open_date = data.content.open_date;
                        self.customer = data.content.customer_number+' | '+data.content.customer_name;
                        self.vehicle_id = data.content.vehicle_id;
                        self.created_by = data.content.uName+' '+data.content.uLastname;
                        self.vendor_claim_number = data.content.vendor_claim_number;
                        self.customer_id = data.content.customer_id;
                        self.work_order_id = data.content.work_order_id;
                        self.wo_item_id = data.content.wo_item_id;
                        self.location_id = {text:data.content.locCode+' | '+data.content.location,value:data.content.location_id};
                        if (data.content.vendor_id){
                            self.vendor = data.content.veName;
                        }
                        self.item_id = 0;
                        self.component_category_id = {text:data.content.vmrsCode+' | '+data.content.code,value:data.content.vmrsid};
                        self.taskid = {value:data.content.taskId,text:data.content.task};
                        self.labor_amount = data.content.labor_amount;
                        self.part_amount = data.content.component_amount;
                        self.original_wo = data.content.original_wo;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'asset-group-warranties-search')
                    }
                });
            },

            createWarrantyWorkOrder(flag) {

                var self = this;
                var error = false;

                var path = window.location.pathname;
                var segments = path.split("/");
                self.open_date_error_msg = "";
                // self.collection_amount_error_msg = '';

                // if (!self.collection_amount || self.collection_amount == null || self.collection_amount == "") {
                //     self.collection_amount_error_msg = "Collection Amount is required.";
                //     error = true;
                // }

                if (!self.open_date || self.open_date == null || self.open_date == "") {
                    self.open_date_error_msg = "Open Date is required.";
                    error = true;
                }


                if (!error) {

                    self.loading = true;
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var id = '';

                    var fields = $('#WarrantyWorkOrderForm').serializeArray();

                    fields.push({name: "location_id", value: self.location_id.value});
                    fields.push({name: "component_id", value: self.component_category_id.value});
                    fields.push({name: "labor_amount", value: self.labor_amount});
                    fields.push({name: "part_amount", value: self.part_amount});
                    if (segments[2] == 'create'){
                        fields.push({name: "claim_id", value: segments[3]});
                        fields.push({name: "id", value:0});
                        fields.push({name: "item_id",value:0});
                    }else{
                        fields.push({name: "id", value: segments[3]});
                    }
                    fields.push({name: "vehicle_id", value: self.vehicle_id});
                    fields.push({name: "customer_id", value: self.customer_id});
                    fields.push({name: "wo_item_id", value: self.wo_item_id});
                    fields.push({name: "parent_id", value: self.work_order_id});
                    fields.push({name: "task_id", value: self.taskid.value});

                    $.ajax({
                        url: process.env.ROOT_API + "/claim-work-order/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;

                            if (data.status == "success") {

                                self.$router.push("/warranty-claim/list");

                            } else {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                    $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (id != '')
                            {
                                $("#createCollectionBtn").val("Update");
                                $("#createCollectionBtn").prop("disabled", false);
                                $("#cancelCollectionBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    // $("#VehicleStatusForm").trigger("reset");

                                    $("#createAndContinueCollectionBtn").val("Save and Continue");
                                    $("#createCollectionBtn").prop("disabled", false);
                                    $("#createAndContinueCollectionBtn").prop("disabled", false);
                                    $("#cancelCollectionBtn").prop("disabled",false);

                                }else{

                                    $("#createCollectionBtn").val("Save");
                                    $("#createCollectionBtn").prop("disabled", false);
                                    $("#createAndContinueCollectionBtn").prop("disabled", false);
                                    $("#cancelCollectionBtn").prop("disabled",false);

                                }
                            }
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");

                                    self.$router.push("/");
                                }
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    });
                }
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/WarrantyWorkOrder.vue